<form style="position: relative;" class="relative">
    <input [formControl]="search" class="input has-clear" type="text" [placeholder]="placeholder" />
    <mat-icon class="input-icon">search</mat-icon>
    <button *ngIf="search.value" type="button" class="search-clear clear-btn" (click)="search.setValue('')" aria-label="Clear search" i18n-aria-label="@@clearSearch"><mat-icon>close</mat-icon></button>
</form>